import React from 'react';
import Autosuggest from 'react-autosuggest';
import createReactClass from 'create-react-class';

const tools = require('form/tools')();
const regexSpaces = /\s/g;

function resetAddressState(props) {
  props.field.state.city = '';
  props.field.state.lat = '';
  props.field.state.lng = '';
  props.field.state.grunnkrets_name = '';
  props.field.state.grunnkrets_number = '';
  props.field.state.grunnkrets_municipality_number = '';

  props.onUpdate();
}

export default createReactClass({
  service: null,
  session: null,
  numberFetchStarted: false,
  numberCauseUpdate: false,
  clickedInside: false,
  apiMinimumLength: 3,
  timeoutValue: 300,
  suggestions: [],
  prevZip: '0000',
  zip_id: 'zip',
  address_id: 'address',

  // field.state.street_number needs to be set before mounting
  componentWillMount() {
    let state = this.props.field.state;
    if (!state.street_number) {
      state.street_number = '';
    }
  },

  componentDidMount() {
    try {
      this.service = new google.maps.places.AutocompleteService();
      this.session = createGoogleSessionToken();

      if (this.props.field.config.zip_id) {
        this.zip_id = this.props.field.config.zip_id;
      }

      if (this.props.field.config.id) {
        this.address_id = this.props.field.config.id;
      }

      this.state.suggestions = [];

      setFieldState(this.props, { selectedSuggestion: null, first_time: true }, ['field', 'state']);
    } catch (e) {
      return;
    }
  },

  async componentDidUpdate() {
    try {
      const { field } = this.props;
      const { state } = field;
      const { zip, street_name, street_number } = state;
      const zipLength = this.props.globalState.fullConfig[this.zip_id].maxLength;

      /* Sikre kompatiblitet med tidligere addressefelt */
      if (zip && street_name && street_number) {
        this.props.field.state.value = `${street_name} ${street_number}`;
      }

      /* Match zip dersom den endrer seg */
      if (zip && zip.length === zipLength && this.prevZip !== zip) {
        this.prevZip = zip;
        if (street_number && street_name && street_number.length > 0 && street_name.length > 0) {
          const result = await getDetailsOnBlurZip.bind(this)(this.props, this.session);
          if (result) {
            setFieldState(
              this.props,
              getGoogleFields.bind(this)(this.props, result.result.address_components),
              ['field', 'state']
            );

            setMatchedState.bind(this)();

            this.forceUpdate();
            this.props.onUpdate();
          }
        }
      }
    } catch (e) {
      return;
    }
  },

  render() {
    const { field } = this.props;
    const { state, config } = field;
    const { label, apiMinimumLength, timeoutValue } = config;
    const { display_value } = state;

    if (apiMinimumLength) {
      this.apiMinimumLength = apiMinimumLength;
    }

    if (timeoutValue) {
      this.timeoutValue = timeoutValue;
    }

    const defaultPlaceholder = this.props.language.address_no_number_placeholder;
    const defaultLabel = this.props.language['address-label'];

    const id = this.props.tools.uniqueId(`${config.id}-street`);

    const inputProps = {
      placeholder: defaultPlaceholder,
      value: display_value || '',
      onChange: this.onChange,
      onBlur: onBlur.bind(this),
      style: { WebkitUserSelect: 'auto' },
      id,
    };

    return (
      <div>
        <div className="lz-input-wrapper">
          <div className="lz-table lz-table-top">
            <div className="lz-table-cell lz-cell-3-4">
              {this.labelAndTinyLabel(id, label || defaultLabel)}
              <Autosuggest
                suggestions={this.state.suggestions}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionHighlighted={this.onSuggestionHighlighted}
                onSuggestionSelected={this.onSuggestionSelected}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                focusInputOnSuggestionClick={false}
                renderInputComponent={this.renderInputComponent}
                renderSuggestionsContainer={this.renderContainer}
                inputProps={inputProps}
              />
            </div>
            {this.numberField()}
          </div>
        </div>
      </div>
    );
  },

  checkmarkAndSpinner() {
    return (
      <div>
        <div className={this.props.spinnerClass}>
          <i className="fa fa-spinner fa-spin" />
        </div>
        <div className="lz-checkmark">
          <i className="fa fa-check" />
        </div>
      </div>
    );
  },

  labelAndTinyLabel(id, label) {
    return (
      <div>
        <label htmlFor={id} style={{ marginBottom: 0.8 + 'em' }}>
          {label}
        </label>
      </div>
    );
  },

  renderInputComponent(inputProps) {
    const { errorClass, errors } = this.props;
    const showErrorClass = shouldShowErrorClass(this.props);
    const { key, ...otherInputProps } = inputProps;

    return (
      <React.Fragment>
        <div className={'lz-input' + (showErrorClass ? errorClass : '')}>
          {this.checkmarkAndSpinner()}
          <input key={key} {...otherInputProps} autoComplete="random-string" />
          <span className="lz-input-bar" />
        </div>
        {errors}
      </React.Fragment>
    );
  },

  numberField() {
    const { errorClass, field } = this.props;
    const showErrorClass = shouldShowErrorClass(this.props);

    const { config } = field;
    const id = this.props.tools.uniqueId(`${config.id}-number`);

    return (
      <div className={'lz-table-cell lz-cell-1-4'}>
        <div style={{ paddingLeft: '5px' }}>
          {this.labelAndTinyLabel(id, this.props.language['address-street-number-label'])}
          <div className={'lz-input' + (showErrorClass ? errorClass : '')}>
            {this.checkmarkAndSpinner()}
            <input
              id={id}
              value={field.state.street_number}
              placeholder={this.props.language['address-street-number-placeholder']}
              onChange={this.onChangeNumber}
              onKeyPress={this.onEnter}
              ref={(input) => {
                this.numberInput = input;
              }}
              onBlur={onBlurNumber.bind(this)}
            />
            <span className="lz-input-bar" />
          </div>
        </div>
      </div>
    );
  },

  /* The predictions shown in the address field. */
  renderContainer({ containerProps, children }) {
    const { key, ...otherProps } = containerProps;
    return (
      <div key={key} {...otherProps}>
        {children}
        <div style={{ background: '#232323', padding: '10px' }}>
          <img src="https://fatcamp.io/statisk.net/images/leazard/powered_by_google_on_non_white.png" />
        </div>
      </div>
    );
  },

  /* Component of the suggestions. */
  renderSuggestion(row) {
    return <div style={{ color: '#333' }}>{row}</div>;
  },

  /* How the value should be presented in the autocomplete */
  getSuggestionValue(arg) {
    return arg;
  },

  getInitialState() {
    return { suggestions: [] };
  },

  onSuggestionHighlighted({ suggestion }) {
    if (suggestion) {
      this.selectedSuggestion = suggestion;
    }
  },

  /* Called when user selects a selection */
  onSuggestionSelected(
    event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) {
    try {
      this.selectedSuggestion = suggestionValue;
      this.numberInput.focus();
    } catch (e) {
      return;
    }
  },

  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] });
  },

  async onSuggestionsFetchRequested({ value }) {
    try {
      if (!this.session) {
        this.session = createGoogleSessionToken();
      }

      if (typeof value === 'undefined') {
        throw new Error('Value is not defined');
      }

      const { field, globalState } = this.props;
      const { countryCode } = globalState.globalConfig;

      /* Wait for user to stop typing */
      this.timeout = setTimeout(async () => {
        const response = await getGooglePredictions.bind(this)(
          value,
          this.service,
          this.session,
          countryCode,
          this.apiMinimumLength
        );
        field.state.liveReference = response;
        this.setState({ suggestions: getSuggestions(response) });
      }, this.timeoutValue);
    } catch (e) {
      throw e;
    }
  },

  /* Called when address field changes */
  onChange(event, { newValue, method }) {
    const { field } = this.props;
    const { state } = field;

    if (typeof this.timeout !== 'undefined') {
      clearTimeout(this.timeout);
    }

    setFieldState(state, { place_id: '' }, ['api']);

    this.prevZip = '0000';

    if (event == null) {
      setFieldState(state, {
        //value: newValue,
        display_value: newValue,
      });

      this.forceUpdate();
      this.props.onUpdate();

      return;
    }

    setFieldState(state, {
      value: newValue,
      display_value: newValue,
      street_name: '',
      street_number: '',
      zip: '',
      google_street_number: '',
      status: 'blurred',
      google_street_name: '',
      zipMatched: false,
      streetNumberMatched: false,
      streetNameMatched: false,
    });

    this.selectedSuggestion = null;

    // Reset zip field in other component
    this.props.globalState.fullState[this.zip_id].value = '';

    this.forceUpdate();
    this.props.onUpdate();
  },

  async onEnter({ key }) {
    try {
      if (key === 'Enter') {
        const result = await getDetailsOnBlurNumber.bind(this)(this.props, this.session);

        if (result) {
          setFieldState(
            this.props,
            getGoogleFields.bind(this)(this.props, result.result.address_components),
            ['field', 'state']
          );
        }

        setFieldState(this.props, { writing_number: false }, ['field', 'state']);

        setMatchedState.bind(this)();

        SetAutomaticZip.bind(this)();

        this.forceUpdate();
        this.props.onUpdate();
      }
    } catch (e) {
      return;
    }
  },

  /* Called when house number changes */
  onChangeNumber({ target }) {
    if (!this.session) {
      this.session = createGoogleSessionToken();
    }

    //prevZip = null

    setFieldState(
      this.props,
      {
        street_number: target.value.replace(' ', ''),
        google_street_number: '',
        google_street_name: '',
        google_zip: '',
        //zip: "",
        zipMatched: false,
        streetNumberMatched: false,
        streetNameMatched: false,
        writing_number: true,
      },
      ['field', 'state']
    );

    // Reset zip field in other component
    //this.props.globalState.fullState.zip.value = ""

    this.forceUpdate();
    this.props.onUpdate();
  },
});

export function setFieldState(obj = {}, valuesToSet, path = []) {
  Object.keys(valuesToSet).forEach((key) => {
    const value = valuesToSet[key];
    const handler = getHandler(value);
    handler(obj, [...path, key], value);
  });

  function getHandler(value) {
    const type = typeof value;
    if (type === 'function') return tools.updateIn;
    else return tools.assocIn;
  }
}

function shouldShowErrorClass(props) {
  const { field } = props;
  const { state } = field;
  const {
    streetNumberMatched,
    streetNameMatched,
    zipMatched,
    first_time,
    street_name,
    street_number,
  } = state;

  /* Checkmarks upon match */
  if (streetNumberMatched && streetNameMatched && zipMatched) {
    //props.field.state.errorClass = "success"
    return true;
  }

  /* Check if fields are missing and not first time input */
  if ((!street_name || !street_number) && !first_time) {
    return true;
  }

  return false;
}

function createGoogleSessionToken() {
  return new google.maps.places.AutocompleteSessionToken();
}

function getGoogleObj(value, list) {
  if (!list || list.length === 0) return {};

  const googleObject = list.filter((address) => {
    const { main_text, secondary_text } = address.structured_formatting;

    const city = getCity(secondary_text);

    return checkIfMatch(value, main_text, city);
  })[0];

  return googleObject || {};
}

function checkIfMatch(value, main_text, city = '') {
  const fullAddress = `${main_text}, ${city}`;

  const addressToLoweCaseNoSpaces = (address) => {
    address.toLowerCase().replace(regexSpaces, '');
  };

  return addressToLoweCaseNoSpaces(value) === addressToLoweCaseNoSpaces(fullAddress);
}

function setMatchedState() {
  const { field } = this.props;
  const { state } = field;
  const { google_street_number, google_street_name, google_zip, zip, street_name, street_number } =
    state;

  if (google_street_name === street_name) {
    this.props.field.state.streetNameMatched = true;
  }

  /* Street name matched */
  if (google_street_name && google_street_name.length > 0) {
    if (google_street_name !== street_name) {
      setFieldState(this.props, { streetNameMatched: false }, ['field', 'state']);
      resetAddressState(this.props);
    } else {
      setFieldState(this.props, { streetNameMatched: true }, ['field', 'state']);
    }
  } else {
    setFieldState(this.props, { streetNameMatched: false }, ['field', 'state']);
    resetAddressState(this.props);
  }

  /* Street number matched */
  if (google_street_number && google_street_number.length > 0) {
    if (google_street_number !== street_number) {
      setFieldState(this.props, { streetNumberMatched: false }, ['field', 'state']);
      resetAddressState(this.props);
    } else {
      setFieldState(this.props, { streetNumberMatched: true }, ['field', 'state']);
    }
  } else {
    resetAddressState(this.props);
    setFieldState(this.props, { streetNumberMatched: false }, ['field', 'state']);
  }

  /* Zip matched */
  if (google_zip && google_zip.length > 0) {
    if (
      google_zip !== zip &&
      (!this.props.field.state.streetNameMatched || !this.props.field.state.streetNumberMatched)
    ) {
      setFieldState(this.props, { zipMatched: false }, ['field', 'state']);
      resetAddressState(this.props);
    } else {
      setFieldState(this.props, { zipMatched: true }, ['field', 'state']);
    }
  } else {
    resetAddressState(this.props);
    setFieldState(this.props, { zipMatched: false }, ['field', 'state']);
  }

  this.forceUpdate();
}

async function onBlurNumber() {
  try {
    if (!this.session) {
      this.session = createGoogleSessionToken();
    }

    if (this.props.field.state.street_number.length <= 0) {
      return;
    }

    const result = await getDetailsOnBlurNumber.bind(this)(this.props, this.session, 'number');

    if (result) {
      setFieldState(
        this.props,
        getGoogleFields.bind(this)(this.props, result.result.address_components),
        ['field', 'state']
      );
    }

    setFieldState(this.props, { writing_number: false, first_time: false }, ['field', 'state']);

    setMatchedState.bind(this)();
    SetAutomaticZip.bind(this)();

    this.forceUpdate();
    this.props.onUpdate();
  } catch (e) {
    setFieldState(this.props, { writing_number: false, first_time: false }, ['field', 'state']);
  }
}

async function onBlur(event, { highlightedSuggestion }) {
  try {
    if (!this.session) this.session = createGoogleSessionToken();

    const { state } = this.props.field;
    const { value } = state;

    if (this.selectedSuggestion != null) {
      //this.onChange(null, { newValue: this.selectedSuggestion });

      const result = await getDetailsOnBlurAddress.bind(this)(this.props, this.session, 'address');
      if (result) {
        setFieldState(
          this.props,
          getGoogleFields.bind(this)(this.props, result.result.address_components),
          ['field', 'state']
        );
        if (hasNumber(this.props.field.state.display_value)) {
          setFieldState(
            this.props,
            {
              display_value: OnlyStreetName(this.props.field.state.display_value),
            },
            ['field', 'state']
          );
        }

        setMatchedState.bind(this)();
        SetAutomaticZip.bind(this)();

        this.forceUpdate();
        this.props.onUpdate();

        return;
      } else {
        this.onChange(null, { newValue: value });
        setFieldState(this.props.field.state, { street_name: value });
      }
    } else {
      this.onChange(null, { newValue: value });
      setFieldState(this.props.field.state, { street_name: value });
    }

    this.forceUpdate();
    this.props.onUpdate();
  } catch (e) {
    throw e;
  }
}

function getGoogleFields(props, address_components) {
  const zip = getValueFromDetails(address_components, 'postal_code').replace(' ', '');
  const city = getValueFromDetails(address_components, 'postal_town');
  const streetName = getValueFromDetails(address_components, 'route');
  const streetNumber = getValueFromDetails(address_components, 'street_number') || '';

  const userInputStreetNumber = tools.getIn(props, ['field', 'state', 'street_number']);
  const userInputZip = tools.getIn(props, ['globalState', 'fullState', this.zip_id, 'value']);
  const streetNumberUsed = chooseNumberToUse(userInputStreetNumber, streetNumber);
  const zipNumberUsed = chooseNumberToUse(userInputZip, zip).replace(' ', '');

  return {
    city,
    zip: zipNumberUsed,
    street_name: streetName,
    street_number: streetNumberUsed,
    google_street_number: streetNumber === streetNumberUsed ? streetNumberUsed : '',
    google_street_name: streetName,
    google_zip: zip === zipNumberUsed ? zipNumberUsed : '',
  };
}

function chooseNumberToUse(userInput, fromGoogle) {
  if (userInput && userInput !== '' && userInput.length > 0 && userInput !== fromGoogle) {
    return userInput;
  }
  return fromGoogle;
}

function getValueFromDetails(list, type) {
  const comp = list.filter((component) => {
    return component.types.indexOf(type) !== -1;
  })[0];
  return comp ? comp.long_name : '';
}

function getSuggestions(value) {
  const pred = value;

  if (!pred || pred.length === 0) {
    return [];
  }

  return pred
    .map((address) => {
      const { structured_formatting } = address;
      const { main_text, secondary_text } = structured_formatting;
      const city = getCity(secondary_text);

      if (!validateCity(city)) {
        return main_text;
      } else {
        return `${main_text}, ${city}`;
      }
    })
    .filter((a) => a);
}

function getCity(text) {
  return String(text).match(/[^,]*/)[0];
}

function validateCity(city) {
  return !/Norway|Sweeden|Norge|Sverige/.test(city);
}

function constructSearchString(number, street) {
  if (street.includes(',')) {
    const split = street.split(',');
    return `${split[0]} ${number}, ${split[1]}`;
  } else {
    return `${street} ${number}`;
  }
}

function hasNumber(myString) {
  return /\d/.test(myString);
}

// Lars eriks gate 21, Kvaløysletta
function OnlyStreetName(street_name) {
  var prevIc = 0;
  var is_comma = false;
  for (let i = 0; i < street_name.length; i++) {
    if (street_name[i] === ',') {
      is_comma = true;
      break;
    }
    if (street_name[i] === ' ') {
      prevIc++;
    }
  }
  const split = street_name.split(' ');
  let res = '';
  for (let i = 0; i < prevIc; i++) {
    if (i == 0) {
      res += split[i].replace(' ', '');
    } else {
      res += ' ' + split[i].replace(' ', '');
    }
  }
  /* Insert everything behind comma if it exist */
  if (is_comma) {
    let commaSplit = street_name.split(',');
    if (typeof commaSplit[commaSplit.length - 1] !== 'undefined') {
      res += ',' + commaSplit[commaSplit.length - 1].replace(' ', '');
    }
  }
  return res;
}

function GetSessionToken(session) {
  const sessionToken = Object.keys(session).reduce((token, key) => {
    token = session[key];
    return token;
  }, '');
  return sessionToken;
}

function SetAutomaticZip() {
  const { field } = this.props;
  const { state } = field;
  const { zip } = state;
  const { streetNameMatched, streetNumberMatched, zipMatched } = state;

  const fullMatch = streetNumberMatched && streetNameMatched && zipMatched;

  if (fullMatch) {
    this.props.globalState.fullState[this.zip_id].value = zip;
  }
}

function GetPlaceId(searchString, state) {
  const obj = getGoogleObj(searchString, state.liveReference);
  const place_id = obj.place_id;
  return place_id;
}

async function getDetailsOnBlurAddress(props, session) {
  return new Promise(async (Resolve, Reject) => {
    try {
      if (!session) {
        Reject(new Error('Google session not established'));
        return;
      }

      const sessionToken = GetSessionToken(session);

      const { globalState, field } = props;

      const { state } = field;

      const { apiKey, countryCode } = globalState.globalConfig;

      const searchString = this.selectedSuggestion;

      if (!searchString) {
        Resolve();
        return;
      }

      await getGooglePredictions.bind(this)(
        searchString,
        this.service,
        this.session,
        countryCode,
        this.apiMinimumLength
      );

      const place_id = GetPlaceId(searchString, state);

      if (!place_id) {
        Reject(new Error('No place id'));
        return;
      }

      modifyApiField(props, true, '', true);

      const result = await callApi.bind(this)(apiKey, place_id, sessionToken);

      modifyApiField(props, false, '', false);

      Resolve(result);
    } catch (e) {
      Reject(e);
    }
  });
}

async function getDetailsOnBlurNumber(props, session) {
  return new Promise(async (Resolve, Reject) => {
    try {
      if (!session) {
        Reject(new Error('Google session not established'));
        return;
      }

      const sessionToken = GetSessionToken(session);

      const { globalState, field } = props;

      const { state } = field;

      const { zip } = state;

      const { apiKey, countryCode } = globalState.globalConfig;

      if (this.selectedSuggestion == null && zip.length <= 0) {
        Resolve();
        return;
      }

      if (this.selectedSuggestion == null && zip.length > 0) {
        const result = await getDetailsOnBlurZip.bind(this)(props, session);
        Resolve(result);
        return;
      }

      const { street_number, street_name } = state;

      if (!street_number || street_number.length == 0) {
        Reject(new Error('Has no street number'));
        return;
      }

      let searchString = null;

      if (hasNumber(this.selectedSuggestion)) {
        searchString = constructSearchString(
          street_number,
          OnlyStreetName(this.selectedSuggestion)
        );
      } else {
        searchString = constructSearchString(street_number, this.selectedSuggestion);
      }

      await getGooglePredictions.bind(this)(
        searchString,
        this.service,
        this.session,
        countryCode,
        this.apiMinimumLength
      );

      const place_id = GetPlaceId(searchString, state);

      if (!place_id) {
        Reject(new Error('No place id'));
        return;
      }

      modifyApiField(props, true, '', true);

      const result = await callApi.bind(this)(apiKey, place_id, sessionToken);

      modifyApiField(props, false, '', false);

      Resolve(result);
    } catch (e) {
      Reject(e);
    }
  });
}

async function getDetailsOnBlurZip(props, session) {
  return new Promise(async (Resolve, Reject) => {
    try {
      if (!session) {
        Reject(new Error('Google session not established'));
        return;
      }

      const sessionToken = GetSessionToken(session);

      const { globalState, field } = props;

      const { state } = field;

      const { apiKey, countryCode } = globalState.globalConfig;

      const { street_name, street_number, zip } = state;

      const searchString = `${street_name} ${street_number}, ${zip}`;

      await getGooglePredictions.bind(this)(
        searchString,
        this.service,
        this.session,
        countryCode,
        this.apiMinimumLength
      );

      const place_id = GetPlaceId(searchString, state);

      if (!place_id) {
        Reject(new Error('No place id'));
        return;
      }

      modifyApiField(props, true, '', true);

      const result = await callApi.bind(this)(apiKey, place_id, sessionToken);

      modifyApiField(props, false, '', false);

      Resolve(result);
    } catch (e) {
      Reject(e);
    }
  });
}

function AddCoordinates(data, props) {
  try {
    if (data.google && data.google.result) {
      let google = data.google.result;
      if (google.geometry) {
        let geometry = google.geometry;
        if (geometry.location) {
          let location = geometry.location;
          if (location.lat && location.lng) {
            setFieldState(props, { lng: location.lng }, ['field', 'state']);
            setFieldState(props, { lat: location.lat }, ['field', 'state']);
          }
        }
      }
    }
  } catch (e) {
    console.log(e);
  }
}

/* Add or remove to grunnkrets to state */
function AddOrRemoveGrunnkrets(data, props) {
  try {
    if (typeof data.grunnkrets == 'undefined') {
      return;
    }

    if (typeof data.grunnkrets.grunnkretsnavn !== 'undefined') {
      setFieldState(props, { grunnkrets_name: data.grunnkrets.grunnkretsnavn }, ['field', 'state']);
    } else {
      setFieldState(props, { grunnkrets_name: '' }, ['field', 'state']);
    }

    if (typeof data.grunnkrets.grunnkretsnummer !== 'undefined') {
      setFieldState(props, { grunnkrets_number: data.grunnkrets.grunnkretsnummer }, [
        'field',
        'state',
      ]);
    } else {
      setFieldState(props, { grunnkrets_number: '' }, ['field', 'state']);
    }

    if (typeof data.grunnkrets.kommunenummer !== 'undefined') {
      setFieldState(props, { municipality_number: data.grunnkrets.kommunenummer }, [
        'field',
        'state',
      ]);
    } else {
      setFieldState(props, { municipality_number: '' }, ['field', 'state']);
    }
  } catch (e) {
    console.log(e);
  }
}

/* Calling the api with the placeid and sessiontoken */
function callApi(key, place_id, sessionToken) {
  return new Promise(async (Resolve, Reject) => {
    try {
      const apiKey = tools.isDev()
        ? 'nO4rMasHdYv7fsEplYHo7reHu0iBxZoCR1EljwkJqcLTHZLT3Q2ofbczZPf75Ma'
        : key;

      let colombiaBug = false;

      // Store old place id
      setFieldState(this.props.field.state, { place_id }, ['api']);

      // Store old place id for field
      setFieldState(this.props, { place_id }, ['field', 'state']);

      let url = new URL('https://leazard.io/api/3/google_places_details');

      const params = {
        key: apiKey,
        q: place_id,
        grunnkrets: true,
        sessiontoken: sessionToken,
      };

      url.search = new URLSearchParams(params).toString();

      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
      });

      const result = await response.text();

      const data = tools.parseJSON(result);

      AddCoordinates(data.result, this.props);

      AddOrRemoveGrunnkrets(data.result, this.props);

      if (data?.result?.result?.address_components) {
        data.result.result.address_components.map((component) => {
          if (component.long_name === 'Colombia') {
            colombiaBug = true;
          }
        });
      }

      colombiaBug ? Resolve([]) : Resolve(data.result);
    } catch (e) {
      Reject(e);
    }
  });
}

function modifyApiField(props, running = false, error = '', apiRequired = false) {
  setFieldState(props, { running, error, apiRequired }, ['field', 'state', 'api']);

  props.onUpdate();
}

/* Collection the google predictions */
async function getGooglePredictions(
  input,
  service,
  sessionToken,
  countryCode = 'se',
  apiMinimumLength
) {
  return new Promise((Resolve, Reject) => {
    try {
      const country = String(countryCode).toLowerCase();
      const value = cleanInput(input);
      const field = this.props.field;

      if (value.length <= apiMinimumLength) {
        // Reject(new Error("Api minimum length not satisifed"))
        return;
      }

      const callback = (res) => {
        field.state.liveReference = res;
        this.setState({ suggestions: getSuggestions(res) });
        Resolve(res);
        return;
      };

      service.getPlacePredictions(
        {
          input: value,
          types: ['address'],
          componentRestrictions: { country },
          sessiontoken: sessionToken,
          language:
            country === 'at'
              ? 'de'
              : country === 'gb'
              ? 'en-GB'
              : country === 'be'
              ? 'nl'
              : country,
        },
        callback
      );
    } catch (e) {
      Reject(e);
      return;
    }
  });
}

/* Trimming the street number when filled directly in the input field.
 * ex: Brinken 41 a => Brinken 41a */
function cleanInput(input) {
  // matchedList - Match number and trailing char/space etc.
  const matchedList = input.match(/[\d]+./g);

  if (matchedList && matchedList[0]) {
    const matchedString = matchedList[0];
    const trimmed = matchedString.trim();
    return input.replace(matchedString, trimmed);
  } else {
    return input;
  }
}
